// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"9aba02c3","167":"298db14a","454":"9aba02c3"}[chunkId] + ".chunk.css";
};